function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-52.126,-52.126)",
  d: "m64.593 60h-2.624a1.969 1.969 0 1 0 0 3.937h2.625a1.969 1.969 0 1 0 0-3.937z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-121.63 -52.126)",
  d: "m144.59 60h-2.625a1.969 1.969 0 0 0 0 3.937h2.625a1.969 1.969 0 0 0 0-3.937z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-191.13 -52.126)",
  d: "m224.59 60h-2.625a1.969 1.969 0 0 0 0 3.937h2.625a1.969 1.969 0 0 0 0-3.937z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-314.49 -301.46)",
  d: "m369.87 347h-6.562a1.312 1.312 0 0 0-1.05 2.1l3.347 4.462-3.347 4.462a1.312 1.312 0 0 0 1.05 2.1h6.562a1.312 1.312 0 0 0 1.312-1.312v-1.312a1.3125 1.3125 0 1 0-2.625 0h-2.625l2.362-3.15a1.312 1.312 0 0 0 0-1.575l-2.362-3.15h2.625a1.3125 1.3125 0 0 0 2.625 0v-1.312a1.312 1.312 0 0 0-1.312-1.313z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-52.126 -156.38)",
  d: "m85.591 180h-23.622a1.969 1.969 0 1 0 0 3.937h23.622a1.969 1.969 0 1 0 0-3.937z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-52.126 -208.5)",
  d: "m85.591 240h-23.622a1.969 1.969 0 1 0 0 3.937h23.622a1.969 1.969 0 1 0 0-3.937z"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-52.126 -260.63)",
  d: "m85.591 300h-23.622a1.969 1.969 0 1 0 0 3.937h23.622a1.969 1.969 0 1 0 0-3.937z"
});
function SvgSum(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("path", {
    d: "m56.254 36.873v-31.247a5.6314 5.6314 0 0 0-5.6247-5.6257h-45.003a5.6314 5.6314 0 0 0-5.6257 5.6257v45.003a5.6314 5.6314 0 0 0 5.6257 5.6257h31.243a14.374 14.374 0 1 0 19.384-19.381zm-52.503-31.247a1.8774 1.8774 0 0 1 1.8755-1.8755h45.003a1.8774 1.8774 0 0 1 1.8755 1.8755v4.3759h-11.876a1.8755 1.8755 0 0 0-1.1716 0.41054l-5.7362 4.5884h-29.97zm1.8755 46.877a1.8774 1.8774 0 0 1-1.8755-1.8755v-31.877h30.627a1.8755 1.8755 0 0 0 1.1716-0.41054l5.7371-4.5893h11.217v21.79a14.383 14.383 0 0 0-16.962 16.962zm44.007 7.7508a10.626 10.626 0 1 1 10.621-10.626 10.638 10.638 0 0 1-10.626 10.626z",
    style: {
      strokeWidth: 0.95254
    }
  }), _ref5, _ref6, _ref7, _ref8));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum);
export default __webpack_public_path__ + "static/media/sum.7684459e.svg";
export { ForwardRef as ReactComponent };